export const DEFAULT_PIP_POSITION = 'bottom-right';
export const DEFAULT_SHOW_CAMERA_FRAMES = true;
export const DEFAULT_CAMERA_BORDER_COLOR = { mode: 'brand' };
//# sourceMappingURL=videoTransform.types.js.map